<div class="policy-outer">
    <div class="policy-wraper">
        <div class="logo-inner">
            <img src="assets/images/terms-logo.png" alt="Terms logo"/>
        </div>
        <h2>Privacy Policy </h2>
        <h3>This Privacy Policy is effective as of September 2023 </h3>
        <p>Welcome to Trucklots ("we," "us," or "our"). Protecting your privacy is important to us. This Privacy Policy
            explains how we collect, use, disclose, and safeguard your information when you use our application. By
            accessing or using our application, you agree to the terms of this Privacy Policy.
        </p>
        <h3>1. Information We Collect</h3>
        <h4> 1.1 Information You Provide </h4>

        <p>When you use our application, we may collect information that you voluntarily provide, including but not
            limited
            to:
        </p>
        <div class="pricing-outer">
            <div class="p-outer">
                <span class="built"></span>
                <p>Personal Information: such as your name, email address, phone number, and payment details.</p>
            </div>
            <div class="p-outer">
                <span class="built"></span>
                <p>Truck Information: details about your truck, such as license plate number and type of truck.</p>
            </div>
            <div class="p-outer">
                <span class="built"></span>
                <p>Location Information: your current location when using the application.</p>
            </div>
            <div class="p-outer">
                <span class="built"></span>
                <p>We may collect personal identification information from users in various ways, including when users
                    make a payment using the Stripe payment gateway. Users may be asked for, as appropriate, name, email
                    address, billing information, and other necessary details. </p>
            </div>
        </div>

<h4>1.2 Information We Collect Automatically</h4>

        <p>We may also collect certain information automatically when you use our application, including:
        <div class="pricing-outer">
            <div class="p-outer">
                <span class="built"></span>
                <p>Device Information: information about your device, including the type, model, operating system, and
                    unique device identifiers. </p>
            </div>
            <div class="p-outer">
                <span class="built"></span>
                <p>Log Information: details about your use of the application, including the pages you view, the time
                    and date of your visit, and the actions you take. </p>
            </div>
        </div>

        <h3> 2. How We Use Your Information</h3>
        <p>We use the information we collect for various purposes, including:</p>
        <div class="pricing-outer">
            <div class="p-outer">
                <span class="built"></span>
                <p>Providing and Improving the Application: to operate, maintain, and enhance its functionality.</p>
            </div>
            <div class="p-outer">
                <span class="built"></span>
                <p>Booking and Payment Processing: to facilitate parking spot bookings and process payments. </p>
            </div>

            <div class="p-outer">
                <span class="built"></span>
                <p>Customer Support: to respond to your inquiries, provide support, and address any issues. </p>
            </div>
            <div class="p-outer">
                <span class="built"></span>
                <p>Marketing and Communications: to send you updates, newsletters, and promotional materials. </p>
            </div>
        </div>

<h3>3. How We Share Your Information</h3>
        <p>
            We may share your information with third parties under the following circumstances:
        </p>

        <div class="pricing-outer">
            <div class="p-outer">
                <span class="built"></span>
                <p>With Your Consent: when you explicitly consent to the sharing of your information.</p>
            </div>

            <div class="p-outer">
                <span class="built"></span>
                <p>Service Providers: with third-party service providers who help us operate, maintain, and improve the
                    application. </p>
            </div>

            <div class="p-outer">
                <span class="built"></span>
                <p>Legal Compliance: when required by law or to protect our rights, interests, or the safety of others.
                </p>
            </div>

        </div>

        <h3>4. Payment Information</h3>
        <p>
            Our app uses Stripe, a third-party payment processor, to securely handle your payment information. We do not
            store your credit card details on our servers. Please refer to Stripe's Privacy Policy for information on
            how they handle your payment data.

        </p>

        <h3>5. Security</h3>
        <p>
            We take reasonable measures to protect your information from unauthorized access, disclosure, alteration, or
            destruction. However, no method of transmission over the internet or electronic storage is completely
            secure,
            and we
            cannot guarantee absolute security.

        </p>

        <h3>6. Your Choices</h3>

        <p>You have choices regarding the information you provide and how it is used:</p>
        <div class="pricing-outer">
            <div class="p-outer">
                <span class="built"></span>
                <p>You can choose not to provide certain information, though it may impact your ability to use certain
                    features of the application.</p>
            </div>

            <div class="p-outer">
                <span class="built"></span>
                <p>You can opt out of receiving promotional emails by following the instructions provided in those
                    emails. </p>
            </div>

</div>
      
        <h3>7. Delete Your Personal Data</h3>
        <p>You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.
        </p>
      
      <p>Our Service may give You the ability to delete certain information about You from within the Service.
You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the Profile section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.
        </p>
        <p>Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.</p>
      
        <h3>8. Changes to this Privacy Policy</h3>

        <p>We may update this Privacy Policy to reflect changes in our practices or for other operational, legal, or
            regulatory reasons. We will notify you of any material changes by posting the updated Privacy Policy on our
            website or through the application.
        </p>

<h3>9. Contact Us</h3>

        <p>If you have any questions or concerns about this Privacy Policy, please contact us at support@trucklots.com.
        </p>
        <p>By using our application, you acknowledge that you have read and understood this Privacy Policy and agree to
            the collection, use, and disclosure of your information as described herein. </p>

</div>
</div>
